/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PlatformNominatedAccountType =
  typeof PlatformNominatedAccountType[keyof typeof PlatformNominatedAccountType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformNominatedAccountType = {
  DEPOSIT: 'DEPOSIT',
  WITHDRAWAL: 'WITHDRAWAL',
  DISTRIBUTION: 'DISTRIBUTION',
} as const;
